import React from 'react';
import { Card, Box } from 'rebass';
import { ICode } from '../type';
import { CONTAINER_PADDING, MAX_WIDTH } from '../common';

interface IProps {
  data: ICode;
}

export default function Code({ data }: IProps) {
  return (
    <Card
      width="100%"
      style={{ maxWidth: MAX_WIDTH - CONTAINER_PADDING * 2 }}
      borderRadius="5px"
      backgroundColor="#111"
      p="10px"
    >
      {data.map((item, index) => (
        <React.Fragment key={index}>
          {item.isNewLine && <Box mb="4px" />}
          {!item.isNewLine && (
            <span
              style={{
                color: item.color,
                fontWeight: 'bold',
                marginLeft: item.marginLeft,
              }}
            >
              {item.text}
            </span>
          )}
        </React.Fragment>
      ))}
    </Card>
  );
}
